import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IIdexxBreedModel extends IModel {
  idexxBreedId: number;
  name: string;
  code: string;
  sort: number;
  species: string;
}

export class IdexxBreedModel
  extends Model
  implements ModelRecord<IIdexxBreedModel>
{
  idexxBreedId: number;
  name: string;
  code: string;
  sort: number;
  species: string;

  constructor(params?: Partial<IIdexxBreedModel>) {
    super(params);
    this.idexxBreedId = defaultTo(params?.idexxBreedId, 0);
    this.name = defaultTo(params?.name, '');
    this.code = defaultTo(params?.code, '');
    this.sort = defaultTo(params?.sort, 0);
    this.species = defaultTo(params?.species, '');
  }
}
